export default __webpack_public_path__ + "static/media/00.34a52da7.jpg";